/* Imports */
import React from "react"
import { Link } from "react-router-dom"
import { Font } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const FontsPage = () => {
    const items = [
        {
            title: "Titles display",
            content: (
                <>
                    <Font.H1 display>Title H1 Display</Font.H1>
                    <Font.H2 display>Title H2 Display</Font.H2>
                    <Font.H3 display>Title H3 Display</Font.H3>
                    <Font.H4 display>Title H4 Display</Font.H4>
                    <Font.H5 display>Title H5 Display</Font.H5>
                </>
            ),
            code: "<Font.H1 display>Title H1 Display</Font.H1>\n<Font.H2 display>Title H2 Display</Font.H2>\n<Font.H3 display>Title H3 Display</Font.H3>\n<Font.H4 display>Title H4 Display</Font.H4>\n<Font.H5 display>Title H5 Display</Font.H5>",
        },
        {
            title: "Titles",
            content: (
                <>
                    <Font.H1>Title H1</Font.H1>
                    <Font.H2>Title H2</Font.H2>
                    <Font.H3>Title H3</Font.H3>
                    <Font.H4>Title H4</Font.H4>
                    <Font.H5>Title H5</Font.H5>
                    <Font.H6>Title H6</Font.H6>
                </>
            ),
            code: "<Font.H1>Title H1</Font.H1>\n<Font.H2>Title H2</Font.H2>\n<Font.H3>Title H3</Font.H3>\n<Font.H4>Title H4</Font.H4>\n<Font.H5>Title H5</Font.H5>\n<Font.H6>Title H6</Font.H6>",
        },
        {
            title: "Paragraphs",
            content: (
                <>
                    <Font.P>Paragraph</Font.P>
                    <Font.P>
                        Paragraph <Font.Strong>strong</Font.Strong>
                    </Font.P>
                    <Font.P>
                        Paragraph <Font.Em>italic</Font.Em>
                    </Font.P>
                    <Font.P>
                        Paragraph with <Link to="#">link</Link>
                    </Font.P>
                    <Font.P>
                        Paragraph with <code>code</code>
                    </Font.P>
                </>
            ),
            code: '<Font.P>Paragraph</Font.P>\n    \n<Font.P>\n    Paragraph <Font.Strong>strong</Font.Strong>\n</Font.P>\n\n<Font.P>\n    Paragraph <Font.Em>italic</Font.Em>\n</Font.P>\n\n<Font.P>\n    Paragraph with <Link to="#">link</Link>\n</Font.P>\n\n<Font.P>\n    Paragraph with <code>code</code>\n</Font.P>',
        },
        {
            title: "Small",
            content: <Font.Small>Small</Font.Small>,
            code: "<Font.Small>Small</Font.Small>",
        },
        {
            title: "Blockquote",
            content: <Font.Blockquote>Blockquote</Font.Blockquote>,
            code: "<Font.Blockquote>Blockquote</Font.Blockquote>",
        },
        {
            title: "Unordered list",
            content: (
                <Font.Ul>
                    <li>Unordered list</li>
                    <li>Unordered list</li>
                    <li>Unordered list</li>
                    <li>Unordered list</li>
                    <li>Unordered list</li>
                </Font.Ul>
            ),
            code: "<Font.Ul>\n    <li>Unordered list</li>\n    <li>Unordered list</li>\n    <li>Unordered list</li>\n    <li>Unordered list</li>\n    <li>Unordered list</li>\n</Font.Ul>",
        },
        {
            title: "Ordered list",
            content: (
                <Font.Ol>
                    <li>Ordered list</li>
                    <li>Ordered list</li>
                    <li>Ordered list</li>
                    <li>Ordered list</li>
                    <li>Ordered list</li>
                </Font.Ol>
            ),
            code: "<Font.Ol>\n    <li>Ordered list</li>\n    <li>Ordered list</li>\n    <li>Ordered list</li>\n    <li>Ordered list</li>\n    <li>Ordered list</li>\n</Font.Ol>",
        },
        {
            title: "Description list",
            content: (
                <Font.Dl>
                    <dt>Description list title</dt>
                    <dd>Description list content</dd>
                    <dt>Description list title</dt>
                    <dd>Description list content</dd>
                    <dt>Description list title</dt>
                    <dd>Description list content</dd>
                    <dt>Description list title</dt>
                    <dd>Description list content</dd>
                    <dt>Description list title</dt>
                    <dd>Description list content</dd>
                </Font.Dl>
            ),
            code: "<Font.Dl>\n    <dt>Description list title</dt>\n    <dd>Description list content</dd>\n    <dt>Description list title</dt>\n    <dd>Description list content</dd>\n    <dt>Description list title</dt>\n    <dd>Description list content</dd>\n    <dt>Description list title</dt>\n    <dd>Description list content</dd>\n    <dt>Description list title</dt>\n    <dd>Description list content</dd>\n</Font.Dl>",
        },
    ]

    const propsItems = [
        {
            name: "color",
            type: "String",
            example: "secondary-400",
            possible: commonProps.allColors,
            default: "black",
        },
        {
            name: "textAlign",
            type: "String",
            example: "center",
            possible: commonProps.textAlign,
            default: "left",
        },
        {
            name: "display (titles from H1 to H5)",
            type: "Boolean",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default FontsPage
